import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Design system styles. Order matters: tokens → components → layout.
import '@styles/colors_and_type.css';
import '@styles/components.css';
import '@styles/site.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found: expected <div id="root"> in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
